import { JourneyName } from "@/sdk"

const journeyNameCreditMatch = {
    feta: "feta_ignition"
}

export function totalOrUnlimited(total?: number) : string{
    if(total === undefined)
        return '0'

    if(total === -1)
        return '∞'

    return total.toString()
}

export function getCreditName(name: JourneyName){
    if(Object.hasOwn(journeyNameCreditMatch, name))
        return journeyNameCreditMatch[name]
    return name
}